import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState("light");

	useEffect(() => {
		const storedTheme = localStorage.getItem("theme");
		if (storedTheme) setTheme(storedTheme);
	}, []);

	useEffect(() => {
		document.documentElement.className = theme;
		localStorage.setItem("theme", theme);
	}, [theme]);

	return (
		<ThemeContext.Provider value={{ setTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useSetTheme = () => {
	const context = useContext(ThemeContext);
	if (!context)
		throw new Error("useSetTheme must be used within ThemeProvider");
	return context;
};
